// test1798
(1798 && 0);
